import ManagePointCategoryContainer from '../../point-setup-forms/ManagePointCategoryContainer';

export type TabType = 'affiliate' | 'club' | 'customer';

export const getTitleByActiveTab = (activeTab: TabType, t: (id: string) => string): string =>
  ({
    affiliate: t('pointManagement.pointsConfiguration.page.table.affiliateTitle'),
    club: t('pointManagement.pointsConfiguration.page.table.clubTitle'),
    customer: t('pointManagement.pointsConfiguration.page.table.customerTitle'),
  })[activeTab];

export const getModalConfig = (activeTab: TabType, t: (id: string) => string) => ({
  modalTitle: 'common.page.modal.managePointCategory.title',
  title: `Manage ${activeTab.charAt(0).toUpperCase()}${activeTab.slice(1)} Category`,
  okText: t('common.page.modal.confirm'),
  cancelText: t('common.page.button.cancel'),
  size: 'lg' as const,
  component: <ManagePointCategoryContainer activeTab={activeTab} />,
});
